module.exports = __webpack_public_path__ + "static/media/giphy_white_large.8e4ac182.png";